'use client';
import { useState } from 'react';

export const LoginForm = () => {
  const [isBusy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (isBusy) {
      return;
    }

    setBusy(true);
    setError('');

    try {
      const formData = new FormData(e.currentTarget);

      const res = await fetch('/api/password-protected/login', {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({ password: formData.get('password') }),
        headers: { 'Content-Type': 'application/json' },
      });

      const data = await res.json();

      if (res.status === 200) {
        // Redirect to home after successful authentication
        window.location.href = '/';
      } else {
        setError(data.message || 'Incorrect password.');
        setBusy(false);
      }
    } catch (_err) {
      setError('An error has occurred.');
      setBusy(false);
    }
  };
  return (
    <div
      style={{
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: '100vw',
        minHeight: '100vh',
        width: '100%',
        overflowX: 'hidden',
      }}
    >
      <div
        style={{
          maxWidth: '100%',
          display: 'flex',
          flex: 1,
          width: '100%',
          padding: '32px 16px',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <style
          dangerouslySetInnerHTML={{
            __html: `
            html {
              font-family: ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";
            }

            body {
              margin: 0;
            }

            * {
              box-sizing: border-box;
            }

            input {
              border: 1px solid #ccc;
              border-radius: 4px;
              padding: 12px;
              font-size: 16px;
              width: 100%;
              max-width: 300px;
              margin-bottom: 16px;
            }

            button {
              background-color: #0070f3;
              color: white;
              border: none;
              border-radius: 4px;
              padding: 12px 32px;
              font-size: 16px;
              cursor: pointer;
              max-width: 300px;
              width: 100%;
              transition: background-color 0.2s;
            }

            button:hover {
              background-color: #0051cc;
            }

            button:disabled {
              background-color: #ccc;
              cursor: not-allowed;
            }

            .error {
              color: #d32f2f;
              margin-bottom: 16px;
              text-align: center;
            }

            .form-container {
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 16px;
            }

            h1 {
              margin-bottom: 24px;
              color: #333;
            }
            `,
          }}
        />

        <div className="form-container">
          <h1>Protected Page</h1>
          <p style={{ color: '#666', marginBottom: '24px' }}>Please enter the password to continue.</p>

          {error && <div className="error">{error}</div>}

          <form
            onSubmit={onSubmit}
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}
          >
            <input type="password" name="password" placeholder="Enter password" required disabled={isBusy} autoFocus />
            <button type="submit" disabled={isBusy}>
              {isBusy ? 'Checking...' : 'Access'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
